import React, { useState } from "react";
import { useTimeline } from "@features/purchasing/hooks/useTimeline";
import { Stack, Typography, useTheme } from "@mui/material"
import { format, isValid } from "date-fns";


interface TimelineItemSegmentProps {
    startDate: Date;
    endDate: Date;
    startOffset?: number;
    color?: string;
}


const TimelineItemSegment: React.FC<TimelineItemSegmentProps> = ({ startDate, endDate, startOffset = 0, color }) => {
    const theme = useTheme();
    const [isHovered, setIsHovered] = useState(false);

    const { getPositionsForDate } = useTimeline();

    // Validate dates before using them
    const isValidStartDate = startDate && isValid(startDate);
    const isValidEndDate = endDate && isValid(endDate);

    // If dates are invalid, don't render the segment
    if (!isValidStartDate || !isValidEndDate) {
        return null;
    }

    // Ensure startDate is before endDate
    if (startDate >= endDate) {
        return null;
    }

    return (
        <div
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                backgroundColor: theme.palette.primary.main,
                boxSizing: 'border-box',

                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',

                padding: '10px',
                borderRadius: '4px',

                position: 'absolute',

                height: '100%',
                left: getPositionsForDate(startDate) - startOffset,
                width: getPositionsForDate(endDate) - getPositionsForDate(startDate) - 2,
                minWidth: '50px',
                border: '1px solid',
                borderColor: 'white',
            }}>

            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" color="white" sx={{ fontSize: '10px' }}>
                    {format(startDate, 'EEE, dd MMM')}
                </Typography>

                <Typography variant="caption" color="white" sx={{ fontSize: '10px' }}>
                    {format(endDate, 'EEE, dd MMM')}
                </Typography>

            </Stack>

            <div style={{
                position: 'absolute',
                bottom: -6,
                width: '100%',
                height: '4px',
                left: 0,
                backgroundColor: color,
                opacity: isHovered ? 1 : (startDate <= new Date() && endDate >= new Date() ? 1 : 0.1),
                borderRadius: '4px',
                transition: 'opacity 0.2s ease-in-out',
            }}>

            </div>
        </div>
    )
}

export default TimelineItemSegment;

